import React from 'react';
import { useIsMobile, useT } from '@repo/common';
import EducationForm from './Education/EducationForm';
import EducationBanner from './Education/EducationBanner';
import StepTitle from '../Common/StepTitle';
import MobileEducationForm from './Education/MobileEducationForm';

const EducationStep = ({ resumeData, setResumeData }) => {
  const t = useT();
  const isMobile = useIsMobile();

  return (
    <div>
      <div className='w-full flex flex-col items-start'>
        {isMobile && (
          <div className='pb-4'>
            <EducationBanner $isMobile={isMobile} />
          </div>
        )}
        <StepTitle title={t('Education', '학력')} $isMobile={isMobile} />
        <div className='w-full flex items-start'>
          <div className='flex-1 tabletH:pr-6'>
            {isMobile ? (
              <MobileEducationForm
                education={resumeData.education}
                setResumeData={setResumeData}
              />
            ) : (
              <EducationForm
                education={resumeData.education}
                setResumeData={setResumeData}
              />
            )}
          </div>
          {!isMobile && <EducationBanner />}
        </div>
      </div>
    </div>
  );
};

export default EducationStep;
